import Swiper from "swiper";

export default class ModalGallerySlider {
  constructor(elem, options = {}) {
    this.elem = $(elem);
    this.swiper = null;

    // Initialize swiper.
    const defaultOptions = {
      slidesPerView: 1,
      navigation: {
        nextEl: this.elem.find(
          ".gallery-overlay .gallery-images-wrap .swiper-button-next"
        ),
        prevEl: this.elem.find(
          ".gallery-overlay .gallery-images-wrap .swiper-button-prev"
        )
      },
      keyboard: {
        enabled: true,
        onlyInViewport: false
      },
      preloadImages: false,
      lazy: true,
      on: {
        init() {
          const title = jQuery($(this)[0].slides[0])
            .find(".content")
            .html();
          $(elem)
            .find(".gallery-info .gallery-content")
            .html(title);
          $(elem)
            .find(".gallery-info .gallery-page-number span.current")
            .html("1");
          $(elem)
            .find(".gallery-info .gallery-page-number span.last")
            .html($(this)[0].slides.length);
        },
        slideChange() {
          const activeIndex = $(this)[0].activeIndex;
          const title = jQuery($(this)[0].slides[activeIndex])
            .find(".content")
            .html();
          $(elem)
            .find(".gallery-info .gallery-content")
            .html(title);
          $(elem)
            .find(".gallery-info .gallery-page-number span.current")
            .html(activeIndex + 1);
        }
      }
    };

    $(document).ready(() => {
      const optionsNew = Object.assign(defaultOptions, options);
      this.swiper = new Swiper(this.elem.find(".swiper-container"), optionsNew);

      this.elem.find(".gallery-overlay").on("click", () => {
        this.elem.removeClass("active");
      });

      this.elem.find(".gallery-images-wrap").click(function(e) {
        e.stopPropagation();
      });
    });

    $(window).on("load", () => {
      this.swiper.update();
    });
  }
}
